import urlParser from '../props/url';
import { DEFAULT_IMAGE_RATIO } from '../const';
import { WEIGHT } from '../../const';

/**
 * Парсер елемента div-element-element
 * @see https://github.yandex-team.ru/portal/morda-schema/blob/master/api/search/2/div/div-image-element.json
 * @param  {Object} element
 * @param  {Number} [props.defaultRatio]
 * @return {Object}
 */
export default (function (element) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$defaultRatio = _ref.defaultRatio,
        defaultRatio = _ref$defaultRatio === undefined ? DEFAULT_IMAGE_RATIO : _ref$defaultRatio;

    if (!element) {
        return null;
    }

    var _element$ratio = element.ratio,
        ratio = _element$ratio === undefined ? defaultRatio : _element$ratio;

    var url = urlParser(element.image_url);

    if (!url) {
        return null;
    }

    return {
        url: url,
        ratio: ratio,
        type: element.type,
        weight: WEIGHT.image
    };
});